import styled from "styled-components";


export const SliderWrap = styled.div`
  position: relative;

`;